export default __webpack_public_path__ + "static/media/background.0f6807be.jpg";